// extracted by mini-css-extract-plugin
export default {"button":"ButtonPeffect_button__IIydh"};